import jsonServerProvider from 'ra-data-json-server';
import { withLifecycleCallbacks } from 'react-admin';

// For Analytics custom call
import { fetchUtils } from 'ra-core';
import { stringify } from 'query-string';


const apiUrl = '/api';
const httpClient = fetchUtils.fetchJson;

function handleUploadedFile( targetField ) {
	return async ( params ) => {
		const field = params.data[targetField];

		if ( field.rawFile instanceof File ) {
			field.type = field.rawFile.type;
			field.rawFile = await convertFileToBase64( field.rawFile );
		}

		return params;
	};
}

function convertFileToBase64( file ) {
	return new Promise( (resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const result = reader.result.split(',')[1];
			resolve( result );
		};

		reader.onerror = reject;
		reader.readAsDataURL( file );
	});
}

export const dataProvider = withLifecycleCallbacks( jsonServerProvider('/api'), [
	{
		resource: 'voiceovers',
		beforeCreate: handleUploadedFile( 'audio' ),
		beforeUpdate: handleUploadedFile( 'audio' )
	}

]);

const buildAPIUrl = ( resource, query ) => {
	return `${apiUrl}/${resource}?${stringify(query)}`;
};

async function getAnalytics(resource, params) {
	const query = {
		...fetchUtils.flattenObject(params.filter)
	};

	const url = buildAPIUrl( resource, query );
	const { json } = await httpClient(url, {
		method: 'POST'
	});
	return { data: json };
};

dataProvider.getAnalytics = async (params) => getAnalytics( 'analytics', params );

dataProvider.getAnalyticsCSV = async (params) => {
	const query = {
		format: 'csv',
		...fetchUtils.flattenObject(params.filter)
	};

	const url = buildAPIUrl( 'analyticscsv', query );
	const { json } = await httpClient(url, {
		method: 'POST'
	});
	return { data: json };
};

dataProvider.refreshSummaries = async ({ force }) => {
	const query = {};
	if ( force ) {
		query.force = 1;
	}

	const url = buildAPIUrl( 'analytics/summaryrefresh', query );
	const { json } = await httpClient(url, {
		method: 'POST'
	});
	return { data: json };
}

export default dataProvider;